<template>
	<div class="px-4 w-100 position-relative">
		<wrapper-mobile-view>
			<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
				<div class="w-100">
					<div class="row">
						<div class="col-1 align-self-center">
							<div @click="backTo()" class="d-inline-grid cursor-pointer">
                <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
              </div>
						</div>
						<div class="col-9 align-self-center">
							<p class="mb-0 body-1-2">{{$t('profile.edit-profile')}}</p>
						</div>
					</div>
				</div>
			</div>
		</wrapper-mobile-view>
		<block :height="57" />
		<div class="w-100 mt-4">
			<div class="d-inline-block cursor-pointer" @click="is_profile = true">
				<div v-if="edit_profile.form.file_preview == null" :style="{'background-image': 'url('+getCurrentUser.avatar+')'}" class="border-profil border-2-green rounded-100 cursor-pointer img-profil d-inline-block" style="padding:1px"></div>
  			<div v-else  :style="{'background-image': 'url('+edit_profile.form.file_preview+')'}" class="border-profil border-2-green rounded-100 cursor-pointer img-profil d-inline-block" style="padding:1px"></div>
  		</div>
  		<div class="bg-light-page d-inline-block border rounded ml-2 cursor-pointer position-relative border" style="top: -28px;padding: 4px 10px;">
  			<img src="../../../assets/img/icon/ar-camera-light.png" width="18" class="d-inline-block position-relative" style="top:-2px">
  			<label for="file_image" class="mb-0 d-inline-block color-light cursor-pointer text-15 font-medium text-color-dark ml-1">{{$t('general.change-photo')}}</label>
  			<input type="file" @change="handleFileChange($event)" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" />
  		</div>
			<div class="pt-4 mb-4">
				<form>
          <div class="mb-3 row">
	          <div class="col-6">
	            <p class="mb-0 body-3-3-1">{{$t('ticket-cart.first-name')}}</p>
	            <input type="text" v-model="edit_profile.form.first_name" class="form-control border-b-semi-grey border-bottom-green px-3 mt-2 body-1-2 mb-1" :placeholder="$t('ticket-cart.first-name')" />
	          </div>
	          <div class="col-6">
	            <p class="mb-0 body-3-3-1">{{$t('ticket-cart.last-name')}}</p>
	            <input type="text" v-model="edit_profile.form.last_name" class="form-control border-b-semi-grey border-bottom-green px-3 mt-2 body-1-2 mb-1" :placeholder="$t('ticket-cart.last-name')" />
	          </div>
	        </div>
	        <div class="mb-3">
	        	<p class="mb-0 body-3-3-1">{{$t('ticket-cart.email')}}</p>
          	<input type="email" v-model="edit_profile.form.email" class="form-control border-b-semi-grey border-bottom-green px-3 mt-2 body-1-2 mb-1" :placeholder="$t('ticket-cart.email')">
	        </div>
	        <div class="row my-4">
	        	<div class="col-12 mb-2" v-if="edit_profile.phone_error.show">
	        		<div class="p-2 border radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
	              <p class="mb-0 body-3-3-1">{{edit_profile.phone_error.message}}</p>
	            </div>
	        	</div>
		        <div class="col-4">
		          <p class="mb-0 body-3-3-1">{{$t('general.country-code')}}</p>
		        </div>
		        <div class="col-8">
		          <p class="mb-0 body-3-3-1">{{$t('general.mobile-number')}}</p>
		        </div>
		        <div class="col-4">
		          <v-select class="mt-2 general-select" :clearable="false" :options="edit_profile.country" v-model="edit_profile.form.dial_code" label="dial_code">
								<template #option="{ dial_code, code }">
									<span class="body-2 mb-0">{{code}} </span>|<span class="body-2 text-color-dark"> {{dial_code}}</span>
								</template>
	          	</v-select>
		        </div>
		        <div class="col-8">
		          <input type="text" v-model="edit_profile.form.phone_number" class="form-control border-b-semi-grey border-bottom-green mt-2 px-3 body-1-2 mb-1" :placeholder="$t('general.mobile-number')">
		        </div>
		      </div>
		      <div class="w-100">
		      	<p class="mb-0 body-3-3-1">{{$t('general.address')}}</p>
  					<textarea class="form-control border-b-semi-grey border-bottom-green px-2 body-1 mb-1 mt-3" v-model="edit_profile.form.address" :placeholder="$t('general.address')"></textarea>
		      </div>
        </form>	
			</div>
			<!-- <wrapper-mobile-view fixed_position="bottom"> -->
				<div class="py-4">
					<div v-if="edit_profile.error.show" class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
		        <p class="mb-0 body-3-1">{{edit_profile.error.message}}</p>
		      </div>
		      <div @click="editProfileSubmit" class="rounded-4 px-4 py-3 text-center" :class="{'bg-green cursor-pointer': is_editprofile_form_valid, 'bg-green-disabled cursor-disable' : !is_editprofile_form_valid || edit_profile.push_loading}">
		      	<pulse-loader :loading="edit_profile.push_loading" v-if="edit_profile.push_loading"></pulse-loader>
		        <p class="text-white body-15 mb-0 ls-1-25" v-else>{{$t('general.save-change')}}</p>
		      </div>
		    </div>
	    <!-- </wrapper-mobile-view> -->
	  </div>
	  <!-- PROFILE -->
	    <transition name="fade">
	    	<template v-if="is_profile">
	        <div class="fixed-top d-block nav-bottom">
	          <div class="custom-container-fluid px-0">
	            <div class="row justify-content-center no-gutters">
	              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative cursor-pointer" @click="is_profile = false">
	                <div class="hide-scroll overflow-scroll" style="background-color:rgba(30, 30, 30, 0.9);z-index: 1055;height: 100vh;">
	                  <div class="w-100">
	                    <div class="text-center box-shadow-1 rounded">
	                      <div class="w-100 pop-up-body">
	                        <!-- <div
	                          class="position-fixed rounded cursor-pointer close-p"
	                          @click="is_profile = false">
	                          <img src="../../../assets/img/icon/cancel.png" class="m-2" width="15" />
	                        </div> -->
													<div class="img-p-c">
														<img :src="getCurrentUser.avatar" class="d-block m-auto w-100 object-fit" height="250">
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</transition>
  </div>
</template>
<script>
	import { parsePhoneNumber,parsePhoneNumberFromString,ParseError  } from 'libphonenumber-js'
	import {post,put} from '@/services/index.js';
	import {mapActions,mapGetters,mapMutations} from 'vuex';
	import country from "@/data/country"
	import {compressImage} from '@/utils/index.js';
	const { email,required,sameAs } = require("vuelidate/lib/validators");

	export default{
		data(){
			return{
				edit_profile:{
					form: {
						first_name: '',
						last_name: '',
						email: '',
						dial_code: '',
						phone_number: '',
						address: '',
						file: null,
						file_preview: null
					},
					country: country,
					error: {
						show: false,
						message: ''
					},
					phone_error:{
						show: false,
						message: ''
					},
					push_loading: false
				},
			is_profile: false
			}
		},
		validations: {
      edit_profile:{
      	form:{
      		first_name:{
      			required
      		},
      		email:{
      			required,
      			email
      		}
      	}
      }
    },
		computed:{
			...mapGetters(['getCurrentUser']),
			is_editprofile_form_valid(){
        return (this.$v.edit_profile.form.first_name.$invalid == false && this.$v.edit_profile.form.email.$invalid == false) ? true : false
      },
		},
		mounted(){
			this.fillDataUser()
			document.addEventListener("keydown", (e) => {
        if (e.keyCode == 27) {
          this.is_profile = false;
        }
	    });
		},
		methods:{
			fillDataUser(){
				this.edit_profile.form.first_name = this.getCurrentUser.first_name
				this.edit_profile.form.last_name = this.getCurrentUser.last_name
				this.edit_profile.form.email = this.getCurrentUser.email
				this.edit_profile.form.address = this.getCurrentUser.address
				if (this.getCurrentUser.phone == '#') {
					this.edit_profile.form.phone_number = ''
	    		this.edit_profile.form.dial_code = this.edit_profile.country.find(x => x.code == 'ID')
				}else{
					const phone_parsed = parsePhoneNumberFromString(this.getCurrentUser.phone)
					if (phone_parsed == undefined || typeof(phone_parsed) == 'undefined') {
						this.edit_profile.phone_error.show = true
		    		this.edit_profile.phone_error.message = 'your phone number ('+this.getCurrentUser.phone+') is invalid'
		    		this.edit_profile.form.phone_number = ''
		    		this.edit_profile.form.dial_code = this.edit_profile.country.find(x => x.code == 'ID')
					}else{
						this.edit_profile.form.dial_code = this.edit_profile.country.find(x => x.code == phone_parsed.country)
						this.edit_profile.form.phone_number = phone_parsed.nationalNumber
					}
				}
				this.edit_profile.form.file = null
				this.edit_profile.form.file_preview = null
			},
			backTo(){
				this.$emit('back')
			},
			handleFileChange(evt){
        this.edit_profile.form.file = evt.target.files[0]
        this.edit_profile.form.file_preview = URL.createObjectURL(evt.target.files[0])
      },
      editProfileSubmit(){
      	if (this.is_editprofile_form_valid && !this.edit_profile.push_loading) {
      		this.edit_profile.error = {
  					show : false,
  					message: ""
  				}
      		this.edit_profile.push_loading = true
      		if (this.edit_profile.form.file == null) {
      			this.pushEditProfile()
      		}else{
      			let self = this
      			compressImage(self.edit_profile.form.file).then(response=>{
      				if(response != false){
      					let fd = new FormData();
			      		fd.append("image_file",response,response.name)
			      		post("BASE","auth/upload-avatar",fd)
			      		.then(response=>{
			      			let res = response.data
			      			if (res.success) {
			      				self.pushEditProfile()
			      			}else{
			      				self.edit_profile.error = {
				    					show : true,
				    					message: res.message
				    				}
				    				self.edit_profile.push_loading = false
			      			}
			      		})
      				}else{
      					self.edit_profile.error = {
		    					show : true,
		    					message: this.$t('warning-message.compress-img.message')
		    				}
      				}
      			})
      		}
      	}
      },
      pushEditProfile(){
      	let params = {}
    		params.first_name = this.edit_profile.form.first_name
    		params.email = this.edit_profile.form.email
    		params.last_name = this.edit_profile.form.last_name
    		params.address = this.edit_profile.form.address
    		if(this.edit_profile.form.phone_number != ''){
    			params.phone = this.edit_profile.form.dial_code.dial_code+this.edit_profile.form.phone_number
    		}
    		put("BASE","auth/profile",params).then(response=>{
    			let res = response.data
    			if (res.success) {
    				this.backTo()
    			}else{
    				this.edit_profile.error = {
    					show : true,
    					message: res.message
    				}
    			}
    			this.edit_profile.push_loading = false
    		})
      },
		}
	}
</script>
<style type="text/css" scoped>
	.general-select .vs__dropdown-toggle, .general-select-sm .vs__dropdown-toggle {
    border-color: #ced4da !important;
    padding-left: 8px;
    border: 1px solid #ced4da!important;
    border-radius: 0.25rem!important;
    height: 45px!important;
  }
  .form-control{
  	border:none;
  	border-radius: 0!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/general/account/EditProfile.vue